module.exports = __webpack_public_path__ + "static/assets/61d4bf6c0e0b711f134158c81f9f6d09.svg";